import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
import { useExperimentalMutation } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalMutation.ts';
import { BadStatusError } from '@confluence/network';

export const useExperimentalMigratePagesMutation = ({
	onCompleted,
	onError,
}: {
	onCompleted?: (data: ExperimentalMigratePagesData) => void;
	onError?: (error: Error) => void;
} = {}) => {
	return useExperimentalMutation<
		ExperimentalMigratePagesData,
		ExperimentalMigratePagesVariables,
		ExperimentalMigratePagesResponse
	>({
		url: ({ contentId, contentHash }) =>
			`/wiki/rest/api/content/${contentId}/convert?hash=${contentHash}`,
		method: 'PUT',
		headers: {
			'Content-Type': MediaType.JSON,
			'X-Requested-With': 'XMLHttpRequest',
		},
		parseResult: (response: ExperimentalMigratePagesResponse) => ({
			experimentalMigratePages: {
				status: String(response.status),
			},
		}),
		parseResponseOnSuccess: async (response: Response) => {
			return { status: response.status };
		},
		parseResponseOnError: async (error) => {
			if (BadStatusError.isBadStatusError(error)) {
				return { status: error.response.status };
			}
			throw error;
		},
		onCompleted,
		onError,
	});
};

interface ExperimentalMigratePagesVariables {
	contentId: string;
	contentHash: string;
}

interface ExperimentalMigratePagesData {
	experimentalMigratePages: {
		status: string;
	};
}

interface ExperimentalMigratePagesResponse {
	status: number;
}
